import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import is from '@sindresorhus/is';
import type { FunctionComponent, ReactNode } from 'react';

import type { SkillShort } from '~/shared/data-contract/skill';

import { ContentWrapper } from '../../../../../design/components/containers/ContentWrapper';
import { Headline } from '../../../../../design/components/Typography';
import { SkillGroupInformation } from '../../../../employee/SkillGroupInformation';
import { HistoryItemInformation } from './HistoryItemSections';

type HistoryItemProps = {
    readonly caption?: ReactNode;
    readonly dateFormat?: string | undefined;
    readonly dateFrom?: string | undefined;
    readonly dateTo?: string | undefined;
    readonly description?: string | undefined;
    readonly onClickEdit?: VoidFunction | undefined;
    readonly skills?: ReadonlyArray<SkillShort> | null | undefined;
    readonly skillsHeadline: string;
    readonly subTitle?: readonly (string | undefined)[] | undefined;
    readonly title: string;
};

export const HistoryItem: FunctionComponent<HistoryItemProps> = (props) => {
    const { caption, dateFormat, dateFrom, dateTo, onClickEdit, skills, skillsHeadline, subTitle, title } = props;

    return (
        <ContentWrapper>
            <Grid container={true} flexDirection="column" gap={3} p={3} pt={2} role="listitem">
                <Grid alignItems="center" container={true} flexWrap="nowrap" justifyContent="space-between">
                    <Grid>{caption}</Grid>
                    {is.function(onClickEdit) === true && (
                        <EditOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClickEdit} />
                    )}
                </Grid>
                <Grid container={true} direction="row">
                    <Grid container={true} display="flex" flexDirection="column" gap={2} size="grow">
                        <Headline variant="h4">{title}</Headline>
                        <HistoryItemInformation
                            dateFormat={dateFormat}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            information={subTitle ?? []}
                        />
                        {!is.nullOrUndefined(skills) && (
                            <SkillGroupInformation headline={skillsHeadline} skills={skills} />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </ContentWrapper>
    );
};
